var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInsurance105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.5 63C52.7761 63 53 63.2239 53 63.5V83.5C53 89.8519 58.1481 95 64.5 95C70.8519 95 76 89.8519 76 83.5C76 83.2239 76.2239 83 76.5 83C76.7761 83 77 83.2239 77 83.5C77 90.4041 71.4041 96 64.5 96C57.5959 96 52 90.4041 52 83.5V63.5C52 63.2239 52.2239 63 52.5 63Z",
  fill: "var(--icon-decorative-coral)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.5 7C52.7761 7 53 7.22386 53 7.5V15.003C73.7732 15.2543 90.9803 31.143 92.9976 51.4506C93.0115 51.5911 92.9654 51.731 92.8706 51.8356C92.7758 51.9403 92.6412 52 92.5 52H72.5107L72.5001 52.0001L72.4895 52H52.5H32.5106L32.5 52.0001L32.4894 52H12.5C12.3588 52 12.2242 51.9403 12.1294 51.8356C12.0346 51.731 11.9885 51.5911 12.0025 51.4506C14.0197 31.143 31.2268 15.2543 52 15.003V7.5C52 7.22386 52.2239 7 52.5 7ZM53 51H72.0001V47.5001C72.0001 33.8644 64.2922 22.2537 53 16.3174V51ZM52 16.3175V51H33V47.5001C33 33.8644 40.7078 22.2537 52 16.3175ZM13.0561 51C15.216 31.9901 31.0481 17.0682 50.3986 16.0549C39.4192 22.321 32 33.9331 32 47.5001V51H13.0561ZM73.0001 47.5001V51H91.9439C89.784 31.9901 73.9519 17.0683 54.6015 16.0549C65.5809 22.321 73.0001 33.9331 73.0001 47.5001Z",
  fill: "currentColor"
})));
export default SvgInsurance105;